import React from 'react'
import CardCarouselEditor from './CardCarouselEditor'
import type { CarouselMetadata } from './CarouselEditor'
import CarouselPreviewPane from './CarouselPreviewPane'

// The grid authors with the exact card-rail config the carousels use
// (tc.widget.card_carousel.v1) — only the client layout differs, and that
// lives in the widget_type. No size/orientation selector: the size is in the
// type name, and the grid is a standalone type rather than a carousel variant.
interface StandardLandscapeGridEditorProps {
  metadata: CarouselMetadata
  onChange: (metadata: CarouselMetadata) => void
  /** Present once the widget row exists; required to upload pin artwork. */
  widgetId?: string
  widgetType: string
}

const StandardLandscapeGridEditor: React.FC<StandardLandscapeGridEditorProps> = ({
  metadata, onChange, widgetId, widgetType,
}) => (
  <>
    <CardCarouselEditor
      metadata={metadata}
      onChange={onChange}
      widgetId={widgetId}
      widgetType={widgetType}
    />
    <CarouselPreviewPane metadata={metadata} onChange={onChange} />
  </>
)

export default StandardLandscapeGridEditor
